module.exports = __webpack_public_path__ + "static/img/find_team_icon.7fbfd17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thirdAnniversary/find_team_icon.png
// module id = szIQ
// module chunks = 2